import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { ReportTypeRes } from "../../types/ResType";

export const useReportTypeList = () => {
  return useQuery<ReportTypeRes, Error>(
    ["report/report-types"],
    async () => {
      const response = await axiosInstance.post<ReportTypeRes>("report/report-types", {});
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
